/*
 * Copyright 2025 iodyne.  All rights reserved.
 * Use is subject to license terms.
 */

import { makeError, type ModelError } from "@/lib/models/errors";
import { translate as t } from "@/i18n/client_nohook";

export async function responseForAPIError(
    resp: {status:number, data?: Record<string,any>}, error_map:Record<string,string>
): Promise<ModelError> {
    if(resp.status == 401) {
        return makeError(
            await t("common.api_errors.not_authenticated"),
            { error_msg: resp.data ? resp.data.toString() : JSON.stringify(resp), must_login: true }
        )
    }
    if(resp.status == 422 && resp.data) {
        return makeError(
            resp.data.detail[0].msg,
            { error_msg: resp.data ? JSON.stringify(resp.data) : JSON.stringify(resp) }
        )
    }
    if (resp.status == 400 && resp.data) {
        var error = resp.data;
        if("details" in Object.keys(error)) {
            error = JSON.parse(error["detail"]);
        }
        for (const key in error_map) {
            if(error.error_class == key) return makeError(error_map[key], error);
        }

        return makeError(
            error.error_description,
            error
        )
    }

    return makeError(
        await t("common.api_errors.unexpected_error"),
        { error_msg: resp.data ? resp.data.toString() : JSON.stringify(resp) }
    )
}